var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"menutoggle pull-left",attrs:{"id":"menuToggle"},on:{"click":_vm.handleSidebarToggle}},[_c('i',{staticClass:"fa fa fa-tasks"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bea0ab0","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sidebar/SidebarCollapse.vue
// module id = 1685
// module chunks = 27